"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SurveyType = exports.SurveySectionType = exports.SurveyQuestionType = exports.PatientAnswerType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SurveyType = {
  id: _propTypes.default.number.isRequired,
  isArchived: _propTypes.default.bool,
  name: _propTypes.default.string.isRequired,
  typeId: _propTypes.default.number.isRequired
};
exports.SurveyType = SurveyType;
var SurveySectionType = {
  id: _propTypes.default.number.isRequired,
  name: _propTypes.default.string.isRequired,
  order: _propTypes.default.number,
  surveyTypeId: _propTypes.default.number.isRequired
};
exports.SurveySectionType = SurveySectionType;
var SurveyQuestionType = {
  id: _propTypes.default.number.isRequired,
  name: _propTypes.default.string,
  surveyId: _propTypes.default.number.isRequired,
  surveySectionId: _propTypes.default.number.isRequired,
  text: _propTypes.default.string.isRequired,
  type: _propTypes.default.number.isRequired,
  note: _propTypes.default.string,
  order: _propTypes.default.number.isRequired,
  required: _propTypes.default.bool.isRequired
};
exports.SurveyQuestionType = SurveyQuestionType;
var PatientAnswerType = {
  answer: _propTypes.default.arrayOf(_propTypes.default.string),
  answerIds: _propTypes.default.arrayOf(_propTypes.default.number),
  createdAt: _propTypes.default.string.isRequired,
  id: _propTypes.default.string.isRequired,
  patientSurveyId: _propTypes.default.string.isRequired,
  isDeleted: _propTypes.default.bool,
  questionId: _propTypes.default.number.isRequired
};
exports.PatientAnswerType = PatientAnswerType;